import React, { useEffect } from "react";
import Frame from "components/shared/Frame";
import { IStep } from "types";
import dean from "assets/shared/characters/Dean2.png";
import trackEvent from "services/tracker.service";

const ConfirmationPage: React.FC<IStep> = ({ value, eventName }) => {
  useEffect(() => {
    eventName && trackEvent(eventName);
  }, [eventName]);

  return (
    <Frame title="YOUR ACCOUNT HAS BEEN CREATED!" showBackBtn={false}>
      <h2 className="my-3">
        <b>Your username: </b>
        <span className="underline">{value?.user?.login_name}</span> <br />
        <b>Password:</b> Choosen during registration
      </h2>
      <a
        onClick={() => {}}
        href="https://portal.heroicgameday.in/login"
        style={{
          fontSize: "28px",
          fontFamily: "Acme",
          cursor: "pointer",
          textDecoration: "underline",
          color: "#0057d3",
        }}
      >
        PLAY NOW!
      </a>
      <p style={{ fontSize: 28, fontFamily: "Acme" }}>Thank you!</p>
    </Frame>
  );
};

export default ConfirmationPage;
